import { useAuth } from '../contexts/AuthContext';

export function usePermissions() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];
  const role = user?.role || 'owner';
  const workspaceId = user?.workspaceId || '';

  const hasPermission = (permission: string): boolean => {
    if (permissions.includes(permission)) return true;
    // Write permission includes the corresponding read capability. Delete and
    // execute deliberately do not imply read, so they cannot expose inventory.
    const [resource, action] = permission.split(':');
    if (['marketing_api_key', 'transactional_api_key', 'web_api_key'].includes(resource)
        && permissions.includes(`api_key:${action}`)) return true;
    if (action === 'read' && permissions.includes(`${resource}:write`)) return true;
    return false;
  };

  const hasAnyPermission = (required: string[]): boolean => {
    return required.some((p) => hasPermission(p));
  };

  const hasAllPermissions = (required: string[]): boolean => {
    return required.every((p) => hasPermission(p));
  };

  const canRead = (resource: string) => hasPermission(`${resource}:read`);
  const canWrite = (resource: string) => hasPermission(`${resource}:write`);
  const canDelete = (resource: string) => hasPermission(`${resource}:delete`);
  const canExecute = (resource: string) => hasPermission(`${resource}:execute`);

  return {
    role, permissions, workspaceId, hasPermission, hasAnyPermission, hasAllPermissions,
    canRead, canWrite, canDelete, canExecute,
  };
}
